// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

/**
 * Format a category label as a possessive form.
 * Handles words ending in 's' correctly (e.g., "Kids" -> "Kid's" instead of "Kids's").
 * 
 * @param {string} categoryLabel - The category label to format
 * @returns {string} The possessive form of the category label
 * 
 * @example
 * formatPossessiveCategory("Kids") // returns "Kid's"
 * @example
 * formatPossessiveCategory("Men") // returns "Men's"
 * @example
 * formatPossessiveCategory("Women") // returns "Women's"
 * @example
 * formatPossessiveCategory("Kid's") // returns "Kid's" (already possessive)
 */
export const formatPossessiveCategory = categoryLabel => {
  if (!categoryLabel) {
    return categoryLabel;
  }
  
  // If it already ends with "'s", return as is
  if (categoryLabel.endsWith("'s")) {
    return categoryLabel;
  }
  
  // If it ends with "s" (but not "'s"), remove the "s" and add "'s" for singular possessive
  // This handles cases like "Kids" -> "Kid's"
  if (categoryLabel.endsWith('s')) {
    return `${categoryLabel.slice(0, -1)}'s`;
  }
  
  // Otherwise, just add "'s"
  return `${categoryLabel}'s`;
};
